// File: typescript/apps/front-end/src/main/react/group/GroupMemberFlairChip.tsx
import React from "react";
import { cn } from "@/lib/utils";

/**
 * A member's leader-granted flair in one group (round 7 slice 2b, D20): the same pill primitive as
 * `GroupLeadershipBadge`, so role and flair read as one system (design §5). The text is member-facing but
 * authored by a leader, so it is never machine-translated (`translate="no"`). Renders nothing without a flair.
 */
export function GroupMemberFlairChip({
    flair,
    playwrightId = "group-member-flair",
    className,
}: {
    flair?: string | null;
    playwrightId?: string;
    className?: string;
}) {
    const text = flair?.trim();
    if (!text) {
        return null;
    }
    return (
        <span
            translate="no"
            data-playwright-id={playwrightId}
            className={cn(
                "inline-flex max-w-full items-center truncate rounded-full border border-border bg-[var(--background1)] px-2.5 py-1 text-xs font-medium text-text-main",
                className,
            )}
        >
            {text}
        </span>
    );
}
